<template>
  <div ref="poster" class="home" :style="{backgroundImage: ranking.brandImage ? `url('${ranking.brandImage}')` : ''}">
    <div class="detail-button" @click="handleShowDetail">活动详情</div>
    <div class="bg-wrapper" @click="jumpPage">
      <span class="brand-title"
            :style="{ padding: ranking.brandText ? '0.1rem' : '0.2rem 0.1rem' }">
        {{ ranking.brandImageTitle }}
      </span>
    </div>
    <img class="logo" v-if="false" src="../assets/logo.png" alt="">
    <div class="title-bar" v-if="false">
      <div class="main-title">{{ ranking.title }}</div>
      <div class="sub-title">（动态更新）</div>
    </div>
    <div class="description" v-if="ranking.brandText">{{ ranking.brandText }}</div>
    <div v-if="ranking.displayChart" :class="['tab-bar', {'tab-bar__graph': curTab === TAB_TYPE.GRAPH}]"
         @click.stop="changeTab">
      <div data-ranking="1"></div>
      <div data-graph="1"></div>
    </div>
    <div class="more-button-wrapper" v-show="curTab === TAB_TYPE.RANKING">
      <div class="more-button" v-if="showArrow" @click="moveRight">
        <img class="icon-arrow-more" src="../assets/icon_arrow_more.png" alt="">
      </div>
    </div>
    <div class="bottom-pane">
      <div class="pane-header">
        <Popover trigger="click" v-model="showPopover" theme="dark" :actions="sortTypes">
          <div class="sort-button" slot="reference">
            <div class="sort-button__text">{{ currentSortType.value }}</div>
            <img class="icon-arrow" :class="{rotate: showPopover}" src="../assets/icon_arrow.png" alt="">
          </div>
          <div class="sort-types">
            <div class="sort-item" :class="{active: sortTypeIndex===st.index}" v-for="st in sortTypes" :key="st.index"
                 @click="selectSortType(st.index)">{{ st.value }}
            </div>
          </div>
        </Popover>
        <Popover trigger="click" v-model="showOrderPopover" theme="dark" :actions="sortOrders"
                 v-if="ranking.displaySort">
          <div class="sort-button sort-order" slot="reference">
            <div class="sort-button__text">{{ currentSortOrder.label }}</div>
            <img class="icon-arrow" :class="{rotate: showOrderPopover}" src="../assets/icon_arrow.png" alt="">
          </div>
          <div class="sort-types sort-order">
            <div class="sort-item" :class="{active: currentSortOrder.value===st.value}" v-for="st in sortOrders"
                 :key="st.index" @click="selectSortOrder(st)">{{ st.label }}
            </div>
          </div>
        </Popover>
        <div class="header-remark" :class="{'has-sort': ranking.displaySort}" v-if="ranking.headerRemark">
          <span>{{ ranking.headerRemark }}</span>
        </div>
      </div>
      <div class="pane-body">
        <div class="rank-table-wrapper">
          <List v-show="curTab === TAB_TYPE.RANKING" :finished="finished" @load="load" v-model="loading"
                finished-text="没有更多数据" :error="error" error-text="请稍后重试" :immediate-check="false" offset="100">
            <table class="rank-table" cellspacing="0" cellpadding="0" border="0">
              <thead class="rank-table-header">
              <tr class="rank-table-row">
                <th class="rank-table-item" v-if="ranking.displayRank">排行</th>
                <th v-for="col in displayList" :key="col.index" class="rank-table-item">{{ col.value }}</th>
              </tr>
              </thead>
              <tbody class="rank-table-body">
              <tr class="rank-table-row" v-for="(row, idx) in tableData" :key="idx" :style="{color: row.color}">
                <td class="rank-table-item" v-if="ranking.displayRank">
                  <img v-if="idx < 5" class="rank-order" :src="require(`../assets/icon_no${idx+1}.png`)" alt="">
                  <template v-else>{{ idx + 1 }}</template>
                </td>
                <td class="rank-table-item" v-for="(dl,i) in displayList" :key="i">
                  <template v-if="row[dl.fieldName]">
                    <span>{{ row[dl.fieldName] }}</span>
                    <template v-if="row.source">
                      <template v-for="(s, si) in row.source">
                        <span :key="si" v-if="s.dataName===dl.fieldName">({{ s.value }})</span></template>
                    </template>
                  </template>
                  <template v-else>-</template>
                </td>
              </tr>
              </tbody>
            </table>
          </List>
          <div class="chart-container" v-show="curTab === TAB_TYPE.GRAPH">
            <div ref="chart" :style="{minHeight: graphHeight + 'px'}" class="chart"></div>
            <div class="load-more-btn" @click="loadMore" v-show="!finished"  ref="loadMoreBtn">
              点击加载更多数据
              <img :class="{loading: loading}" src="@/assets/icon_loading.png" />
            </div>
          </div>
          <div class="bottom-placeholder"></div>
        </div>
        <template v-if="ranking.footRemark">
          <div class="noted-text">{{ ranking.footRemark }}</div>
        </template>
      </div>
    </div>
    <transition name="faded">
      <div data-html2canvas-ignore class="detail-overlay" v-if="showDetail" @click.self="handleHideDetail">
        <div class="detail-body">
          <div class="detail-title">活动详情</div>
          <div class="detail-content">{{ ranking.details }}</div>
          <img @click.stop="handleHideDetail" class="popup-close-icon" src="../assets/icon_delete.png" alt="关闭弹窗">
        </div>
      </div>
    </transition>
    <Overlay data-html2canvas-ignore :show="showLoading">
      <div class="loading-wrapper">
        <Loading/>
      </div>
    </Overlay>
  </div>
</template>

<script>
import { List, Loading, Overlay, Popover, PullRefresh } from 'vant'
// import BetterScroll from '@better-scroll/core'
import { getRankList } from '@/api'
import getUrlParams from '@/utils/getUrlParams'
import { isWeChat } from '@/utils/env'
import loadjs from 'loadjs'
import { WX_JSAPI_URL } from '@/utils/constants'
import initWxShare from '@/utils/wx'
import $ from 'jquery'
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, GridComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import html2canvas from 'html2canvas'
import { imgUrlToBase64, loadImg } from '@/utils/base64'

echarts.use([TitleComponent, TooltipComponent, GridComponent, BarChart, CanvasRenderer])
let chart = null

const TAB_TYPE = {
  RANKING: 0,
  GRAPH: 1,
}

export default {
  name: 'DefaultTemplate',
  props: {
    rankingDetails: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Popover,
    List,
    Loading,
    Overlay,
    // PullRefresh,
  },
  data () {
    return {
      showLoading: true,
      showDetail: false,
      showPopover: false,
      showOrderPopover: false,
      sortTypeIndex: -1,
      sortOrders: [
        {
          label: '升序',
          value: 'ASC',
        }, {
          label: '降序',
          value: 'DESC',
        },
      ],
      currentSortOrder: {},
      tableData: [],
      bs: null,
      pageNum: 0,
      pageSize: 20,
      total: 0,
      loading: false,
      refreshing: false,
      finished: false,
      error: false,
      showArrow: false,
      curTab: TAB_TYPE.RANKING,
      TAB_TYPE,
      graphHeight: 0,
      isFirstInitGraph: true,
    }
  },
  computed: {
    ranking () {
      return this.rankingDetails || {}
    },
    currentSortType () {
      return this.sortTypes.find(st => st.index === this.sortTypeIndex) || {}
    },
    rankId () {
      const { id } = getUrlParams()
      return id
    },
    sortTypes () {
      return this.ranking.sortList || []
    },
    displayList () {
      return this.ranking.displayList || []
    },
  },
  async created () {
    this.sortTypeIndex = this.sortTypes[0]?.index
    this.currentSortOrder = this.sortOrders[1]
    await this.refresh()
    this.initChart()
    this.showLoading = false
    this.$nextTick(() => {
      const $table = document.querySelector('.rank-table')
      const $bp = document.querySelector('.bottom-placeholder')
      const $nt = document.querySelector('.noted-text')
      const $hr = document.querySelector('.header-remark')
      // 自动隔离底部
      if ($nt && $bp) {
        $bp.style.height = $nt.clientHeight + 'px'
      }
      // 跑马灯
      if ($hr && $hr.scrollWidth > $hr.clientWidth) {
        $hr.classList.add('marquee')
        $hr.querySelector('span').style.webkitAnimationDirection = $hr.scrollWidth / $hr.clientWidth * 4 + 's'
        $hr.querySelector('span').style.animationDuration = $hr.scrollWidth / $hr.clientWidth * 4 + 's'
      }
      // 自动显示箭头
      if ($table && $table.clientWidth > window.screen.width) {
        this.showArrow = true
      }
      window.parent.postMessage({ type: 'pageInit' }, '*')
    })
  },
  mounted () {
    window.addEventListener('message', (e) => {
      if (e.data.type !== 'poster') {
        return
      }
      this.$nextTick(() => {
        this.generatePoster()
      })
    })
  },
  methods: {
    jumpPage () {
      this.ranking.brandImageLink && window.open(this.ranking.brandImageLink)
    },
    fetchRankData () {
      const page = this.pageNum
      return getRankList({
        rankId: this.rankId,
        page,
        size: this.pageSize,
        sort: this.sortTypeIndex,
        direction: this.currentSortOrder?.value || 'asc',
      }).then(res => {
        this.pageNum += 1
        return (res.data?.content || []).map(row => {
          const fields = this.sortTypes.map(st => st.fieldName)
          const result = {
            color: '',
          }
          fields.forEach((field, index) => {
            result[index] = row[field]
          })
          return row
        })
      }).catch(() => {
        return []
      })
    },
    async load () {
      this.loading = true
      await this.fetchRankData().then(content => {
        this.tableData = this.tableData.concat(content || [])
        if (content?.length < this.pageSize) {
          this.finished = true
        }
      })
      this.loading = false
    },
    async loadMore () {
      await this.load()
      this.initChart()
    },
    async refresh () {
      this.pageNum = 0
      this.finished = false
      this.loading = true
      await this.fetchRankData().then(content => {
        this.tableData = content || []
        if (content?.length < this.pageSize) {
          this.finished = true
        }
      })
      this.loading = false
      this.refreshing = false
    },
    initChart () {
      if (this.curTab !== TAB_TYPE.GRAPH) {
        return
      }
      if (!chart) {
        chart = echarts.init(this.$refs.chart)
      }
      const { value, fieldName } = this.currentSortType
      const option = {
        title: {
          text: value,
          x: 'center',
          y: 'top',
          textAlign: 'left',
          top: 10,
          textStyle: {
            color: '#666666',
            fontSize: 15,
            fontStyle: 'normal',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          top: 51,
          bottom: 10,
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: '#333333',
          },
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            color: '#333333',
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          data: [],
        },
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: 8,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: 'rgba(12,191,255,0.30)' }, { offset: 1, color: '#3882FF' },
              ]),
            },
            label: {
              show: true,
              distance: -12,
              color: '#999999',
            },
            data: [],
          },
        ],
      }
      this.tableData.reduceRight((preData, curData) => {
        option.yAxis.data.push(curData.name)
        const data = curData[fieldName] >= 0
          ? {
            value: curData[fieldName],
            itemStyle: { borderRadius: [0, 2, 2, 0] },
            label: {
              position: 'insideTopRight',
            },
          } : {
            value: curData[fieldName],
            itemStyle: {
              borderRadius: [2, 0, 0, 2],
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#FF7A38' },
                { offset: 1, color: 'rgba(255,138,12,0.30)' },
              ]),
            },
            label: {
              position: 'insideTopLeft',
            },
          }
        option.series[0].data.push(data)
      }, {})
      this.graphHeight = this.tableData.length * 31 + 81
      chart.resize({ height: this.graphHeight })
      chart.setOption(option)
      !this.isFirstInitGraph && this.$nextTick(() => {
        const doc = document.documentElement
        doc.scrollTop = doc.scrollHeight
      })
      this.isFirstInitGraph = false
    },
    changeTab (e) {
      const type = e.target.dataset.graph ? TAB_TYPE.GRAPH : TAB_TYPE.RANKING
      if (type === this.curTab) {
        return
      }
      this.curTab = type
      if (this.curTab === TAB_TYPE.GRAPH) {
        this.isFirstInitGraph = true
        this.initChart()
      }
    },
    handleShowDetail () {
      this.showDetail = true
    },
    handleHideDetail () {
      this.showDetail = false
    },
    async selectSortType (index) {
      this.isFirstInitGraph = true
      this.sortTypeIndex = index
      const $wrapper = document.documentElement
      if ($wrapper) {
        $wrapper.scrollTop = 0
      }
      await this.refresh()
      this.initChart()
      this.showPopover = false
    },
    async selectSortOrder (so) {
      this.isFirstInitGraph = true
      this.currentSortOrder = so
      const $wrapper = document.documentElement
      if ($wrapper) {
        $wrapper.scrollTop = 0
      }
      await this.refresh()
      this.initChart()
      this.showOrderPopover = false
    },
    moveRight () {
      const $wrapper = document.querySelector('.rank-table-wrapper')
      if ($wrapper) {
        $($wrapper).animate({
          scrollLeft: $wrapper.scrollLeft + window.screen.width,
        }, 300)
      }
    },
    moveLeft () {
      const $wrapper = document.querySelector('.rank-table-wrapper')
      if ($wrapper) {
        $($wrapper).animate({
          scrollLeft: $wrapper.scrollLeft - window.screen.width,
        }, 300)
      }
    },
    async generatePoster () {
      const { brandImage, shareQrcode } = this.ranking
      this.ranking.brandImage = await imgUrlToBase64({ url: brandImage })
      this.ranking.shareQrcode = await imgUrlToBase64({ url: shareQrcode })
      const dom = this.$refs.poster
      const width = window.innerWidth; const height = window.innerHeight
      html2canvas(dom, {
        scrollX: 0,
        scrollY: 0,
        scale: 2,
        width,
        height,
        backgroundColor: '#fff',
        imageTimeout: 0,
        useCORS: true,
        allowTaint: true,
      }).then(async canvas => {
        const pic = await this.drawShareQrCode(canvas, this.ranking.shareQrcode, width, height)
        window.parent.postMessage({ type: 'posterBase64Img', data: pic }, '*')
      })
    },
    async drawShareQrCode (canvas, shareQrcode, width, height) {
      const ctx = canvas.getContext('2d')
      const imgW = 86; const imgH = 86
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, height - 100, width, height)
      const shareQrCodeImg = await loadImg(shareQrcode)
      ctx.drawImage(shareQrCodeImg, width / 2 - imgW / 2, height - 100 + (100 - imgH) / 2, imgW, imgH)
      return canvas.toDataURL('image/jpeg', 1)
    },
  },
}
</script>
<style lang="less" scoped>

@pane-header-height: 0.5rem;
@table-header-height: 0.4rem;
@bottom-height: 0.37rem;
@no-tab-mt: 0.15rem;
.home {
  position: relative;
  min-height: 100vh;
  background-position: top center;
  background-size: 100% 2.11rem;
  background-repeat: no-repeat;

  /deep/ .van-list__error-text, /deep/ .van-list__finished-text, /deep/ .van-list__loading {
    height: @table-header-height;
    line-height: @table-header-height;
    font-size: 0.13rem;
  }
}

.detail-button {
  position: absolute;
  right: 0;
  top: 0.2rem;
  width: 66px;
  min-height: 24px;
  line-height: 24px;
  padding-left: 0.12rem;
  background: rgba(0, 0, 0, 0.60);
  border-radius: 1rem 0 0 1rem;
  font-size: 12px;
  color: #FFFFFF;
  z-index: 99;
}

.description {
  padding: 0.15rem;
  word-break: break-all;
  color: #333333;
  font-size: 0.15rem;
  line-height: 0.21rem;

  & + .tab-bar {
    margin-top: 0;
  }
}

.tab-bar {
  width: 100vw;
  height: 0.6rem;
  margin-top: 0.15rem;
  background: url("~@/assets/tab_ranking.png") no-repeat center;
  background-size: cover;
  display: flex;

  & > div {
    flex: 1;
  }

}

.tab-bar__graph{
  background: url("~@/assets/tab_graph.png") no-repeat center;
  background-size: cover;
}

.detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
}

.detail-body {
  position: fixed;
  top: 44.4%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background: #ffffff;
  width: 3.2rem;
  height: 3.69rem;
  padding: 0.2rem 0.1rem;
  border-radius: 0.1rem;
}

.detail-title {
  font-size: 0.18rem;
  color: #333333;
  line-height: 0.25rem;
  text-align: center;
}

.detail-content {
  margin-top: 0.1rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  line-height: 0.21rem;
  color: #666666;
  overflow-y: scroll;
  height: 2.94rem;
}

::-webkit-scrollbar-thumb {
  width: 0.06rem;
  height: 0.25rem;
  background-color: #E9E9E9;
  border-radius: 0.05rem;
}

.popup-close-icon {
  width: 0.24rem;
  height: 0.24rem;
  position: absolute;
  bottom: -0.1rem;
  left: 50%;
  transform: translateX(-50%) translateY(100%);
}

.bg-wrapper {
  //position: absolute;
  //top: 0;
  //left: 0;
  position: relative;
  height: 2.11rem;
  width: 100%;

  .brand-title{
    display: inline-block;
    position: absolute;
    bottom: 0;
    right: 0;
    word-break: break-all;
    text-align: right;
    color: white;
    font-size: 0.14rem;
    line-height: 0.2rem;
  }

  & + .more-button-wrapper + .bottom-pane {
    margin-top: -@no-tab-mt;
  }

  & + .more-button-wrapper > .more-button {
    top: @pane-header-height - @no-tab-mt
  }

  & + .tab-bar {
    margin-top: -0.2rem;
  }
  //background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, .7));
}

.bottom-pane {
  //position: absolute;
  bottom: 0;
  width: 100%;
  //height: calc(100% - 52.2vw);
  //height: calc(100% - 1.96rem);
  border-radius: 0.15rem 0.15rem 0 0;
  background: #ffffff;
}

.pane-header {
  height: @pane-header-height;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 0.15rem;
}

.sort-button {
  font-size: 0.14rem;
  color: #666666;
  border: 1px solid #dddddd;
  border-radius: 0.165rem;
  width: 1.47rem;
  height: 0.3rem;
  padding: 0 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &.sort-order {
    margin-left: 0.1rem;
    width: 0.64rem;

  }

  .sort-button__text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    letter-spacing: -0.01rem;
  }

}

.sort-types {
  width: 1.47rem;
  color: #FFFFFF;
  padding: 0.1rem 0;

  &.sort-order {
    width: 0.63rem;
  }
}

.sort-item {
  font-size: 0.14rem;
  line-height: 0.2rem;
  text-align: center;

  &.active {
    color: #43A0FF;
    font-weight: bold;
  }

  &:not(:first-child) {
    margin-top: 0.15rem;
  }
}

.icon-arrow {
  flex-shrink: 0;
  width: 0.1rem;
  height: 0.06rem;
  margin-left: 0.05rem;
  transform: rotateZ(0);
  transform-origin: center center;
  //transition: transform 0.3s linear;
  &.rotate {
    transform: rotateZ(-0.5turn);
  }
}

.pane-body {
  position: relative;
  width: 100%;
  //height: calc(100% - @pane-header-height);
  //overflow: auto;
  padding-bottom: 0;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  display: flex;
  flex-direction: column;

  .chart-container{
    text-align: center;
    .chart {
      width: calc(100vw - 0.2rem);
      height: calc(100vh - 2.46rem);
      border-radius: 0.06rem;
      border: 0.01rem solid #dddddd;
      margin: 0.1rem;
    }

    .load-more-btn {
      padding: 0.05rem 0.15rem;
      background-color: rgba(67, 160, 255, 0.12);
      border-radius: 0.165rem;
      font-size: 0.14rem;
      color: #43a0ff;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0.1rem;
      user-select: none;

      &>img{
        width: 0.12rem;
        height: 0.12rem;
        margin-left: 0.05rem;
      }
    }

    .loading {
      animation: loading 2.5s ease-in-out infinite;
    }
  }
}

.rank-table-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.rank-table {
  border-spacing: 0;
  border-collapse: collapse;
  //position: relative;
  //height: 100%;
  min-width: 100vw;
  //width: 1000px;
  font-size: 0.15rem;
  color: #333333;
}

.rank-table-header {
  //display: table;
  width: 100%;
  //table-layout: fixed;
  border-top: 1px solid #DDDDDD;
  border-bottom: 1px solid #DDDDDD;
  color: #666666;
  height: @table-header-height;
  font-size: 0.15rem;
  line-height: 0.21rem;
  //padding-top: 0.09rem;
  background-color: #FFFFFF;

  .rank-table-row {
    //display: table;
    //table-layout: fixed;
    //width: 100%;

    .rank-table-item {

      .remark {
        font-size: 0.14rem;
        line-height: 0.2rem;
        color: #999999;
      }
    }
  }

}

.rank-table-row {
  //display: table;
  table-layout: fixed;
  width: 100%;
  height: 0.4rem;
}

.rank-table-body {
  //display: block;
  width: 100%;
  overflow-y: auto;
  height: 100%;

  tr {
    //display: table;
    //table-layout: fixed;
  }
}

.rank-table-body-pull-refresh {
  min-height: 100%;
  width: 100%;
}

.rank-table-body-inner {
  min-height: calc(100vh - 1.96rem - @pane-header-height - @table-header-height);
}

.rank-table-item {
  font-weight: normal;
  padding: 0 0.13rem;
  min-height: 0.4rem;
  text-align: center;
  font-size: 0.15rem;
  line-height: 0.21rem;
  white-space: nowrap;
  @media (max-width: 320px) {
    font-size: 0.13rem;
  }
}

.faded-enter-active,
.faded-leave-active {
  transition: all 0.1s ease-in-out;
}

.faded-enter, .faded-leave-to {
  opacity: 0;
}

.header-remark {
  width: calc(100% - 1.57rem);

  &.has-sort {
    width: calc(100% - 1.67rem - 0.64rem);
  }

  margin-left: 0.1rem;
  font-size: 0.14rem;
  color: #999999;
  text-align: right;
  overflow: hidden;
  white-space: nowrap;
  flex-shrink: 0;

  &.marquee {
    span {
      display: inline-block;
      animation: marquee 10s linear infinite;
    }
  }
}

@keyframes marquee {
  from {
    transform: translateX(50vw);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes loading {
  0% {
    transform: rotateZ(0);
  }
  50% {
    transform: rotateZ(-360deg);
  }
  100% {
    transform: rotateZ(-360deg);
  }
}

.noted-mark {
  font-size: 0.15rem;
  color: #999999;
}

.noted-text {
  position: fixed;
  width: 100vw;
  bottom: 0;
  padding: 0.1rem 0.165rem;
  padding-bottom: 0.1rem;
  padding-bottom: calc(0.1rem + env(safe-area-inset-bottom));
  padding-bottom: calc(0.1rem + constant(safe-area-inset-bottom));
  line-height: 0.17rem;
  font-size: 0.12rem;
  color: #999999;
  background: #f7f7f7;
  @media (max-width: 374px) {
    font-size: 12px;
  }
}

.bottom-placeholder {
  width: 100%;
  height: @bottom-height;
}

//.logo {
//  position: absolute;
//  top: 0.12rem;
//  left: 0.1rem;
//  width: 2.08rem;
//  height: auto;
//}

//.title-bar {
//  position: absolute;
//  top: 0.75rem;
//  width: 100%;
//  text-align: center;
//}

//.main-title {
//  width: 100%;
//  height: auto;
//  font-family: fangzheng, 'PingFang SC', 'Noto SansCJK', 'Microsoft Yahei', 'Heiti SC', serif;
//  font-weight: normal;
//  text-align: center;
//  font-size: 0.26rem;
//  color: #FFFFFF;
//}

//.sub-title {
//  margin-top: 0.05rem;
//  font-size: 0.14rem;
//  color: rgba(255, 255, 255, 0.7);
//}

.rank-order {
  width: 0.34rem;
  height: 0.14rem;
}

//@font-face {
//  font-family: fangzheng;
//  src: url("../assets/fonts/FZZDHJW.TTF");
//}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.more-button-wrapper {
  position: sticky;
  top: 1.8rem;
  z-index: 10;
}

.more-button {
  position: absolute;
  top: @pane-header-height;
  right: 0;
  height: @table-header-height;
  width: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-image: linear-gradient(270deg, #FFFFFF 0%, rgba(255,255,255,0.00) 100%);

  .icon-arrow-more {
    margin-right: 0.05rem;
    height: 0.1rem;
  }
}
</style>
